import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import "./Router.css";

import MainDashboard from "./components/dashboards/MainDashboard";
import LessonDashboard from "./components/dashboards/LessonDashboard";
import RoadTestDashboard from "./components/dashboards/RoadTestDashboard";
import PaymentDashboard from "./components/dashboards/PaymentDashboard";
import FiveHourDashboard from "./components/dashboards/FiveHourDashboard";
import PackagesDashboard from "./components/dashboards/PackagesDashboard";
import BasicInfoDashboard from "./components/dashboards/BasicInfoDashboard";
import NotFound from "./components/core/NotFound";
import Header from "./components/layout/Header";
import Sidebar from "./components/layout/Sidebar";

import { studentId } from "./helpers";

class MainRouter extends React.Component {
  state = {
    activeMenu: "main",
    activeTitle: "Dashboard"
  };
  updateNav = (activeMenu, activeTitle) => {
    const newState = { ...this.state, activeMenu, activeTitle };
    this.setState(newState);
  };

  render() {
    if (studentId === undefined)
      return <h3>Unable to find ID, Please call office</h3>;

    return (
      <Router>
        <div className="container-fluid">
          <div className="row">
            <Header activeTitle={this.state.activeTitle} />
            <Sidebar activeMenu={this.state.activeMenu} />
            <main className="main-content">
              <Switch>
                <Route
                  exact
                  path="/app/student-dashboard"
                  render={props => (
                    <MainDashboard {...props} updateMenu={this.updateNav} />
                  )}
                />

                <Route
                  path="/app/student-dashboard/lessons"
                  render={props => (
                    <LessonDashboard {...props} updateMenu={this.updateNav} />
                  )}
                />
                <Route
                  exact
                  path="/app/student-dashboard/roadtests"
                  render={props => (
                    <RoadTestDashboard {...props} updateMenu={this.updateNav} />
                  )}
                />
                <Route
                  path="/app/student-dashboard/payments"
                  render={props => (
                    <PaymentDashboard {...props} updateMenu={this.updateNav} />
                  )}
                />
                <Route
                  path="/app/student-dashboard/fivehourclass"
                  render={props => (
                    <FiveHourDashboard {...props} updateMenu={this.updateNav} />
                  )}
                />
                <Route
                  path="/app/student-dashboard/packages"
                  render={props => (
                    <PackagesDashboard {...props} updateMenu={this.updateNav} />
                  )}
                />
                <Route
                  path="/app/student-dashboard/basicinfo"
                  render={props => (
                    <BasicInfoDashboard
                      {...props}
                      updateMenu={this.updateNav}
                    />
                  )}
                />
                <Route>
                  <Redirect to="/app/student-dashboard" />
                </Route>
                <Route component={NotFound} />
              </Switch>
            </main>
          </div>
        </div>
      </Router>
    );
  }
}

export default MainRouter;
